import React from "react";
import styles from "./machine-node-unit-fields.module.scss";
import { DashboardEditWidgetDrawerDropdown } from "@src/components/atoms/dashboard-edit-widget-drawer-dropdown/dashboard-edit-widget-drawer-dropdown";
import { NameAndSourceId } from "@common/types/server-list-types";

const cssClassName = "machine-node-unit-fields";

/** Labels for the three dropdowns. Each editor passes its own module's
 *  wording, so this component carries no translations of its own. */
export interface MachineNodeUnitFieldsTexts {
  machineLabel: string;
  noMachines: string;
  machinesPlaceholder: string;
  nodeLabel: string;
  noNodes: string;
  nodesPlaceholder: string;
  unitLabel: string;
  noUnits: string;
  unitsPlaceholder: string;
}

interface MachineNodeUnitFieldsProps {
  texts: MachineNodeUnitFieldsTexts;
  machineOptions: NameAndSourceId[];
  selectedMachine: NameAndSourceId | null;
  onSelectMachine: (machine: NameAndSourceId | null) => void;
  isLoadingMachines: boolean;
  nodeOptions: NameAndSourceId[];
  selectedNode: NameAndSourceId | null;
  onSelectNode: (node: NameAndSourceId | null) => void;
  isLoadingNodes: boolean;
  unitOptions: NameAndSourceId[];
  selectedUnit: NameAndSourceId | null;
  onSelectUnit: (unit: NameAndSourceId | null) => void;
  isLoadingUnits: boolean;
}

/**
 * The machine / node / unit dropdown trio the single-source widget editors
 * show. Dumb on purpose: it renders what it is given and reports picks back,
 * so each editor keeps its own state, its own option lists and its own
 * side-effects (clearing a node when the machine changes, auto-picking a
 * unit, …).
 */
export const MachineNodeUnitFields = ({
  texts,
  machineOptions,
  selectedMachine,
  onSelectMachine,
  isLoadingMachines,
  nodeOptions,
  selectedNode,
  onSelectNode,
  isLoadingNodes,
  unitOptions,
  selectedUnit,
  onSelectUnit,
  isLoadingUnits,
}: MachineNodeUnitFieldsProps) => (
  <>
    <div className={styles[`${cssClassName}__field`]}>
      <DashboardEditWidgetDrawerDropdown
        options={machineOptions}
        selectedOption={selectedMachine}
        onSelectOption={onSelectMachine}
        labelText={texts.machineLabel}
        noOptionsText={texts.noMachines}
        placeholderText={texts.machinesPlaceholder}
        isLoading={isLoadingMachines}
      />
    </div>

    <div className={styles[`${cssClassName}__field`]}>
      <DashboardEditWidgetDrawerDropdown
        options={nodeOptions}
        selectedOption={selectedNode}
        onSelectOption={onSelectNode}
        labelText={texts.nodeLabel}
        noOptionsText={texts.noNodes}
        placeholderText={texts.nodesPlaceholder}
        isLoading={isLoadingNodes}
      />
    </div>

    <div className={styles[`${cssClassName}__field`]}>
      <DashboardEditWidgetDrawerDropdown
        options={unitOptions}
        selectedOption={selectedUnit}
        onSelectOption={onSelectUnit}
        labelText={texts.unitLabel}
        noOptionsText={texts.noUnits}
        placeholderText={texts.unitsPlaceholder}
        isLoading={isLoadingUnits}
      />
    </div>
  </>
);
